import { Component } from '@angular/core';

/**
 * RIA-only thinking loader: light bulb + shimmering "Thinking" header
 * and a single bullet message inside a rounded panel.
 */
@Component({
  selector: 'app-ria-thinking-loader',
  templateUrl: './ria-thinking-loader.component.html',
  styleUrls: ['./ria-thinking-loader.component.scss']
})
export class RiaThinkingLoaderComponent {}
